// Camera models organized by brand
export const CAMERA_BRANDS = {
  Canon: [
    "EOS R1","EOS R3","EOS R5 Mark II","EOS R5","EOS R5 C","EOS R6 Mark II","EOS R6","EOS R8","EOS R7","EOS R10","EOS R50","EOS R100","EOS RP","EOS R",
    "Cinema EOS C70","Cinema EOS C80","Cinema EOS C200","Cinema EOS C300 Mark III","Cinema EOS C400","Cinema EOS C500 Mark II",
    "EOS-1D X Mark III","EOS-1D X Mark II","EOS 5D Mark IV","EOS 5D Mark III","EOS 6D Mark II","EOS 6D","EOS 90D","EOS 80D","EOS 7D Mark II"
  ],
  Sony: [
    "Alpha a1","Alpha a1 II","Alpha a9 III","Alpha a7 V","Alpha a7 IV","Alpha a7 III","Alpha a7R V","Alpha a7R IV","Alpha a7S III",
    "FX3","FX30","FX6","FX9","ZV-E10","ZV-E10 II","a6700","a6600","a6400","RX100 VII","ZV-1 II"
  ],
  Nikon: [
    "Z9","Z8","Z6 III","Z6 II","Z6","Z7 II","Z7","Zf","Z5","Z50","Z50 II","Z fc","Z30",
    "D6","D5","D850","D780","D750","D500","D7500","D7200"
  ],
  Fujifilm: ["X-H2S","X-H2","X-T5","X-T50","X-S20","X-Pro3","X100VI","GFX100 II","GFX100S II","GFX50S II"],
  "Panasonic (LUMIX)": ["S1H","S1","S1R","S5 II","S5 IIX","S9","GH7","GH6","G9 II","G95 / G90"],
  "OM System / Olympus": ["OM-1 Mark II","OM-1","OM-5","OM-5 Mark II","E-M1 Mark III","E-M1X","E-M5 Mark III","E-M10 Mark IV"],
  Leica: ["SL2-S","SL2","SL3","Q2","Q3","M11"],
  "Blackmagic Design": ["Pocket Cinema Camera 4K","Pocket Cinema Camera 6K","Pocket Cinema Camera 6K Pro","Pocket Cinema Camera 6K G2","URSA Mini Pro 12K","Cinema Camera 6K"],
  RED: ["KOMODO","KOMODO-X","V-RAPTOR","V-RAPTOR XL"],
  DJI: ["Ronin 4D (6K)","Ronin 4D (8K)","Osmo Pocket 3","Osmo Action 4"],
  GoPro: ["HERO12 Black","HERO11 Black","HERO10 Black"],
};

export const CODEC_OPTIONS = ["H264","H265","ProRes","DNxHD","Other"];
export const COMPRESSION_OPTIONS = ["Max Depth","Long GOP","Other"];
export const FPS_OPTIONS = ["23.976","24","25","29.97","30","60","Other"];
export const RESOLUTION_OPTIONS = ["1920x1080","2560x1440","3840x2160","Other"];
export const NLE_OPTIONS = ["Adobe Premiere","Final Cut Pro X","DaVinci Resolve","No preference"];
// YouTube sits after HTFW and Wayward North, the two named YouTube channels, so a client who came
// through one of those sees the specific answer before the generic one (2026-09-22; ~27 had typed
// it under Other). Stored answers are bucketed by the report scripts, never rewritten here.
export const HOW_HEARD_OPTIONS = ["Social Media","Google","Referral","HTFW","Wayward North","YouTube","AI Chatbot","Reddit","CrowdReel","Pixally","Other"];
export const WEDDINGS_OPTIONS = ["<10","10-20","20-30","30-40","40+"];

// Photo style dropdowns
export const WHITE_BALANCE_OPTIONS = ["Cool","Neutral","Warm"];
export const EXPOSURE_OPTIONS = ["Bright & airy","Neutral","Moodier"];
export const SKIN_TONE_OPTIONS = ["Neutral","Slightly warmer"];
export const BW_USAGE_OPTIONS = ["Never","Rarely","Sometimes","Often"];
export const CROP_OPTIONS = ["As shot","Auto-straighten only","Crop tighter"];
export const BURST_OPTIONS = ["Keep best only","Keep best 2","Keep all"];
